<div class="flex w-full border-b gap-4">
	<div
		class="flex gap-2 p-4 duration-300 cursor-pointer group border-b-2 border-transparent -mb-[1px]"
		*ngFor="let tab of tabs"
		(click)="updateSelectedTab(tab.value)"
		[ngClass]="{
			'border-green-600 [&>h4]:text-gray-950': selectedTab === tab.value,
			'border-transparent': selectedTab !== tab.value,
		}"
		[attr.data-intercom-target]="tab.intercomAttr"
	>
		<h4 class="h4 mb-0 duration-300 text-gray-500 group-hover:text-gray-950">
			{{ tab.label }}
		</h4>
		<ng-container *ngIf="tab.newFlag">
			<ui-pill [type]="pillTypes.NEW"></ui-pill>
		</ng-container>
	</div>
</div>
